<template>
  <div class="forum-items">
    <div class="forum-box" @click="goDetails(item.id)">
      <div class="forum-box-title">{{ item.title }}</div>
      <div class="forum-box-content">
        <img
          v-if="item.images"
          :src="item.images ? item.images[0] : ''"
          alt=""
        />
        <div class="forum-box-content-item">
          <span>{{ richTextFormat }}</span>
          <span class="lookDetails" v-if="richTextFormat.length > 280">
            查看详情
          </span>
        </div>
      </div>
      <!-- 帖子操作 -->
      <div class="forum-box-msg" v-if="operation">
        <div class="forum-box-msg-user">
          <img :src="item.user ? item.user.avatar : ''" alt="" />
          <img
            v-if="item.user.is_official_user"
            src="../../assets/image/gx_icon.png"
            class="gx_icon"
            alt=""
          />
          <div class="forum-box-msg-user-name">
            {{ item.user ? item.user.nickname : "" }}
            <span class="gx_text" v-if="item.user.is_official_user">官方</span>
          </div>
          <div class="forum-box-msg-user-time">{{ item.dateTime }}</div>
        </div>
        <div class="forum-box-msg-comment">
          <div
            class="forum-box-msg-comment-box"
            @click.stop="postLike(item.id)"
          >
            <img
              v-if="item.is_like == 0 || !item.is_like"
              src="../../assets/image/like.png"
              alt=""
            />
            <img v-else src="../../assets/image/checkLike.png" alt="" />
            <!-- <img src="../../assets/image/like.png" alt=""> -->
            <div>{{ item.like_num }}次赞</div>
          </div>
          <div class="forum-box-msg-comment-box">
            <img src="../../assets/image/comment.png" alt="" />
            <div>{{ item.comment_num }}条评论</div>
          </div>
          <div class="forum-box-msg-comment-box" @click.stop="collect(item.id)">
            <img
              v-if="item.is_collect == 0 || !item.is_collect"
              src="../../assets/image/collection.png"
              alt=""
            />
            <img v-else src="../../assets/image/checkCollect.png" alt="" />
            <div>
              {{ item.is_collect == 0 || !item.is_collect ? "收藏" : "已收藏" }}
            </div>
          </div>
          <!-- <div class="forum-box-msg-comment-box">
            <img src="../../assets/image/share.png" alt="" />
            <div>分享</div>
          </div> -->
          <div
            class="forum-box-msg-comment-box"
            v-if="isDel"
            @click.stop="del(item.id)"
          >
            <img src="../../assets/image/del.png" alt="" />
            <div>删除</div>
          </div>
        </div>
      </div>
      <!-- 我的评论 -->
      <div class="forum-box-comment" v-else>
        <div class="forum-box-comment-box">
          <img src="../../assets/image/headImg.png" alt="" />
          <div class="forum-box-comment-box-right">
            <!-- 头部 -->
            <div class="forum-box-comment-box-right-user">
              <span>快乐的何同学</span><span>11小时前</span>
            </div>
            <!-- 内容 -->
            <div class="forum-box-comment-box-right-content">
              双方常规开局。1分05秒重庆狼队拿下中路河道之灵。
            </div>
            <!-- 操作 -->
            <div class="forum-box-comment-box-right-operation">
              <div class="forum-box-comment-box-right-operation-box">
                <img src="../../assets/image/like.png" alt="" />
                <span>23</span>
              </div>
              <div class="forum-box-comment-box-right-operation-box">
                <img src="../../assets/image/del.png" alt="" />
                <span>删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    operation: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },
    isDel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    richTextFormat() {
      let value = this.item.content;
      // value = value.replace(/<\/?.+?>/g,'')
      // value = value.replace(/\s+/g,'')
      if (value.length > 280) {
        return value.slice(0, 280) + "...";
      }
      return value;
    },
  },
  methods: {
    postLike(id) {
      this.$emit("postLike", id);
    },
    collect(id) {
      this.$emit("collect", id);
    },
    goDetails(id) {
      this.$emit("goDetails", id);
    },
    del(id) {
      this.$emit("del", id);
    },
  },
};
</script>
<style lang="scss">
.forum-items {
  .forum-box {
    border-bottom: 1px solid #f9fafd;
    padding: 20px 0;
    .forum-box-title {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1e2134;
      line-height: 30px;
    }
    .forum-box-content {
      margin: 15px 0 20px 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      img {
        width: 240px;
        height: 145px;
        border-radius: 4px;
      }
      .forum-box-content-item {
        margin-left: 20px;
        // border: #3D7EFF solid 1px;
        span {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 30px;
          color: #1e2134;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 4;
          // overflow: hidden;
        }
        .lookDetails {
          white-space: nowrap;
          font-size: 18px;
          color: #3d7eff;
        }
      }
    }
    .forum-box-comment {
      .forum-box-comment-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        img {
          width: 55px;
          height: 55px;
          border-radius: 50%;
        }
        .forum-box-comment-box-right {
          padding: 10px 0 0 0;
          margin-left: 12px;
          .forum-box-comment-box-right-user {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            span {
              &:nth-child(1) {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1e2134;
              }
              &:nth-child(2) {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #858585;
                margin-left: 26px;
              }
            }
          }
          .forum-box-comment-box-right-content {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e2134;
            margin: 8px 0 15px 0;
          }
          .forum-box-comment-box-right-operation {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            .forum-box-comment-box-right-operation-box {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              margin-right: 20px;
              img {
                width: 20px;
                height: 20px;
              }
              span {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #506176;
                margin-left: 5px;
              }
            }
          }
        }
      }
    }
    .forum-box-msg {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .forum-box-msg-user {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        .gx_icon {
          position: absolute;
          left: 15px;
          bottom: -5px;
          width: 21px;
          height: 21px;
        }
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
        .forum-box-msg-user-name {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1e2134;
          margin: 0 15px 0 10px;
          .gx_text {
            width: 30px;
            height: 16px;
            border-radius: 4px;
            color: #fff;
            font-size: 10px;
            padding: 2px 4px;
            background: linear-gradient(154deg, #fff116 0%, #ff8703 100%);
            margin-left: 5px;
          }
        }
        .forum-box-msg-user-time {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #858585;
        }
      }
      .forum-box-msg-comment {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .forum-box-msg-comment-box {
          cursor: pointer;
          margin-left: 20px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
          div {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #506176;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>